import React from "react";
import { Text, Tooltip, SkeletonLoader } from "@merge-api/merge-javascript-shared";
import { Info } from "lucide-react";

type LinkedAccountsCountsCardDataRowProps = {
  text: string;
  count?: number;
  tooltipText?: string;
};

const LinkedAccountsCountsCardDataRow: React.FC<LinkedAccountsCountsCardDataRowProps> = ({
  text,
  count,
  tooltipText,
}) => {
  return (
    <div className="flex justify-between items-center self-stretch">
      <div className="flex items-center gap-2">
        <Text className="text-black font-inter text-base font-normal leading-5">{text}</Text>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <Info size={16} />
          </Tooltip>
        )}
      </div>
      {typeof count === "number" ? (
        <Text className="text-black font-inter text-base font-normal leading-5">
          {count.toLocaleString()}
        </Text>
      ) : (
        <SkeletonLoader height={10} borderRadius={10} />
      )}
    </div>
  );
};

export default LinkedAccountsCountsCardDataRow;
